import { render, staticRenderFns } from "./ProductCodeBox.vue?vue&type=template&id=899b7096&scoped=true&"
import script from "./ProductCodeBox.vue?vue&type=script&lang=js&"
export * from "./ProductCodeBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899b7096",
  null
  
)

export default component.exports